import React, { useState } from "react";
import TaqwaLogoRemoved from "../../images/taqwa-removed.png";
import CircularProgress from "@mui/material/CircularProgress";
import supabase from "../../supabase";
import { Turnstile } from "@marsidev/react-turnstile";
export default function Login() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaStatus, setCaptchaStatus] = useState("loading"); // 'loading', 'success', 'error'
  const [retryCount, setRetryCount] = useState(0);

  const [error, setError] = useState("");
  
  async function signIn(event) {
    event.preventDefault();
    
    // Only block if captcha is still loading and we are in an environment that expects it
    if (captchaStatus === "loading" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || process.env.REACT_APP_CLOUDFLARE_SITE_KEY)) {
      setError("Security verification is loading. Please wait a moment or check your connection.");
      return;
    }

    try {
      setLoading(true);
      setError("");
      const options = {};
      if (captchaToken) {
        options.captchaToken = captchaToken;
      }
      const { data, error: authError } = await supabase.auth.signInWithPassword({
        email,
        password,
        options,
      });
      if (authError) {
        setError(authError.message || authError.error_description || "Authentication failed. Please check your credentials.");
      } else {
        const role = data?.user?.app_metadata?.userrole || data?.user?.app_metadata?.role;
        if (!role || role.toLowerCase() !== "admin") {
          setError("Access denied. You do not have administrator privileges.");
          await supabase.auth.signOut();
        }
      }
    } catch (err) {
      setError(err?.message || "An unexpected error occurred during login.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page-login flex items-center justify-center h-screen bg-gray-400  ">
      <div
        className="cont-google text-center bg-white p-10 w-[70%] "
        style={{
          boxShadow:
            "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
        }}
      >
        <img src={TaqwaLogoRemoved} alt="TAQWA" className="mx-auto mb-6" />
        <span className="block logo-label text-2xl mb-2">FASHION STORE</span>
        <span className="block text-right text-[0.9em] mb-6">Admin Portal</span>
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4 text-sm">
            {error}
          </div>
        )}
        <form onSubmit={signIn}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full px-3 py-2 mb-4 border rounded focus:outline-none focus:border-blue-500"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full px-3 py-2 mb-6 border rounded focus:outline-none focus:border-blue-500"
          />
          <button
            type="submit"
            disabled={loading || captchaStatus === "loading"}
            className={`w-full px-6 py-2 text-white rounded font-bold transition-colors ${
              loading || captchaStatus === "loading"
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-black cursor-pointer"
            }`}
          >
            {loading ? (
              <CircularProgress style={{ color: "#fff" }} size={18} />
            ) : (
              "Sign In"
            )}
          </button>
          
          <div className="mt-4 flex flex-col items-center">
            <Turnstile
              key={`turnstile-${retryCount}`}
              siteKey={
                window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
                  ? "1x00000000000000000000AA" // Cloudflare Always Pass Test Key
                  : process.env.REACT_APP_CLOUDFLARE_SITE_KEY
              }
              onSuccess={(token) => {
                setCaptchaToken(token);
                setCaptchaStatus("success");
                setError("");
              }}
              onError={() => {
                setCaptchaStatus("error");
                setCaptchaToken("");
                setError("Security verification failed. You may proceed without it or retry.");
              }}
            />
            {captchaStatus === "error" && (
              <button
                type="button"
                onClick={() => {
                  setCaptchaStatus("loading");
                  setError("");
                  setRetryCount(prev => prev + 1);
                }}
                className="mt-2 text-blue-500 hover:text-blue-700 text-sm underline"
              >
                Retry Security Verification
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
